import { WizDatasource } from '../services/collections/wiz-datasource';
import { WizComponentManager } from './../services/core/component/wiz-component.manager';
import { Directive, ComponentRef, ViewContainerRef, Input, NgModule } from '@angular/core';
/**
 * Interface that allows the definition of an item renderer
 */
export interface IWizItemRenderer<C, T> {
  /**
   * The execution context for the rendered item.
   *
   * It must have a property that specifies the item renderer
   */
  context?: C;

  /**
   * The actual data that needs to be rendered
   */
  data: T;

  /**
   * Sets the component owning the data renderer
   */
  owner?: any;

  /**
   * datasource complète du parent
   */
  provider?: any;

}

/**
 * Directive that helps building dynamic item renderer without the need of any templating
 */
@Directive({
  selector: '[wizTemplateItemRenderer]'
})
export class WizItemRendererDirective<C extends { itemRenderer }, T> {

  private _componentRef: ComponentRef<IWizItemRenderer<C, T>>;

  private _data: T;

  constructor(private _vcRef: ViewContainerRef) { }

  /**
   * Sets the execution context. The context will provide the component class ref to build
   */
  @Input() set wizTemplateItemRenderer(renderer: any) {
    if (!this._componentRef) {
      this._componentRef = WizComponentManager.instance.addChildTo(renderer, this._vcRef);
    }
  }

  /**
   * Sets the data that needs to be rendered
   */
  @Input() public set data(value: T) {
    this._data = value;
    if (this._componentRef) {
      this._componentRef.instance.data = value;
    }
  }

  public get data(): T {
    return this._data;
  }

  /**
   * Sets the data that needs to be rendered
   */
  @Input() set context(value: C) {
    if (this._componentRef) {
      this._componentRef.instance.context = value;
    }
  }

  /**
   * Owner of the renderer
   */
  @Input() set owner(value: any) {
    if (this._componentRef) {
      this._componentRef.instance.owner = value;
    }
  }
  @Input()
  public set provider(value: WizDatasource<any>) {
    if (this._componentRef) {
      this._componentRef.instance.provider = value;
    }
  }


}

/**
 * This directive does absolutely nothing.
 *
 * Its only purpose is to be used as a token for ContentChild selection.
 *
 * Since @ContentChild does not support attribute selection.
 * We must use a directive to avoid id duplication inside any template
 */
@Directive({
  selector: '[wizTemplateRenderer]'
})
export class WizTemplateRendererDirective {
  constructor() { }
}

@NgModule({
  declarations: [
    WizItemRendererDirective,
    WizTemplateRendererDirective
  ],
  exports: [
    WizItemRendererDirective,
    WizTemplateRendererDirective
  ]
})
export class WizItemRendererModule { }
